import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// eslint-disable-next-line import/no-unresolved
import 'react-toastify/dist/ReactToastify.min.css';
import App from './App';
import OncolensToast from './components/OncolensToast';
import Logger from '@/utils/loggingService';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Helmet titleTemplate={`%s | OncoLens`} defaultTitle={'OncoLens'} />
        <App />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
    <OncolensToast />
  </React.StrictMode>,
  document.querySelector('#root'),
);

Logger.initializeLogger();
